import { ArrowLeft, ArrowRight, CheckCircle, LockSimple } from "@phosphor-icons/react";

export function BackArrow({ onClick, testid = "step-back-arrow" }) {
  return (
    <button type="button" onClick={onClick} aria-label="Previous step" data-testid={testid}
      className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0A3622] hover:-translate-x-0.5 transition-transform mb-4">
      <ArrowLeft size={16} weight="bold" /> Previous step
    </button>
  );
}

/** Read-only summary of a completed step, with an optional edit action and a Next button. */
export function ReviewPanel({ title, rows, locked, closed, onNext, children, testid = "step-review" }) {
  return (
    <div className="rounded-2xl border border-[#E5E3DB] bg-white p-6" data-testid={testid}>
      <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
        <h3 className="font-display text-xl font-medium">{title}</h3>
        <span className="badge badge-success inline-flex items-center gap-1" data-testid="step-review-completed"><CheckCircle size={12} weight="fill" /> Completed</span>
      </div>
      <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
        {rows.filter(([, v]) => v !== undefined && v !== null && v !== "").map(([k, v]) => (
          <div key={k}>
            <dt className="text-[11px] uppercase tracking-[0.12em] text-[#4F5D4F]">{k}</dt>
            <dd className="font-medium text-[#132A13] mt-0.5 break-words">{v}</dd>
          </div>
        ))}
      </dl>
      {locked && (
        <p className="mt-5 text-xs text-[#4F5D4F] flex items-center gap-1.5" data-testid="step-review-locked">
          <LockSimple size={14} weight="fill" /> {closed ? "This application is closed, so these details can't be changed." : "Your application is submitted, so these details can't be changed."}
        </p>
      )}
      {children && <div className="mt-5">{children}</div>}
      <button type="button" onClick={onNext} className="btn-primary mt-6" data-testid="step-review-next">
        Next <ArrowRight size={14} weight="bold" />
      </button>
    </div>
  );
}
